import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  //课程列表
  courseList: [],
  //题库列表
  bankListPage: [],
  bankListPageNo: 1,                                    // 试题库列表页面当前页数
  bankListPageSize: types.SCROLL_LOADING.BANK_LIST_PAGE_SIZE  // 试题库列表页面每页数量
}

const actions = {
  /**
   * 查询题库
   * @param commit
   * @param name
   */
  selectExerciseBank({commit}, param){
    let params = {
      courseId: param.courseId,
      bankName: param.name,
      pageNo: state.bankListPageNo,
      pageSize: state.bankListPageSize
    }
    http.selectExerciseBank(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_BANK_LIST_PAGE", res.data);
      }
    })
  },

  /**
   * 创建题库
   * @param commit
   * @param param
   */
  createBank({commit}, param){
    let params = {
      bankName: param.bankName,
      courseId: param.courseId,
    }

    http.createExerciseBank(params).then(res => {
      param.success(res);
    })
  },

  /**
   * 查询课程列表
   * @param commit
   */
  selectCourse({commit}){
    http.GetMyCourses().then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_COURSE_LIST", res.data);
      }
    });
  },

  /**
   * 更新题库
   * @param commit
   * @param bank
   */
  updateBank({commit}, param){
    http.updateExerciseBank(param).then(res => {
      param.success(res);
    });
  },
  // 改变当前页数
  setBankListPageNo({commit}, params){
    commit("SET_BANK_LIST_PAGE_NO", params);
  },

  /**
   * 删除题库
   * @param commit
   * @param param
   */
  deleteBank({commit},param){
    http.deleteExerciseBank({bankId:param.id}).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        param.success();
      }
    });
  },
  setBankListPage(params) {
	  commit("SET_BANK_LIST_PAGE", params);
  }
}

const getters = {}

const mutations = {
  ['SET_BANK_LIST_PAGE'](state, page) {
    Vue.set(state, 'bankListPage', page);
  },
  ['SET_COURSE_LIST'](state, list) {
    Vue.set(state, 'courseList', list);
  },
  ['SET_BANK_LIST_PAGE_NO'](state, params) {
    Vue.set(state, 'bankListPageNo', params);
  },
  ['SET_BANK_LIST_PAGE_SIZE'](state, params) {
    Vue.set(state, 'bankListPageSize', params);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/topiclibrary.js